<script setup lang="ts">
defineProps<{
  /** スライド数の最大値 */
  max: number,
  /** 現在のスライドインデックス */
  currentSlideIndex: number
}>();
</script>

<template>
  <div class="inquiry-form-header">
    <div class="inquiry-form-step">
      <span class="inquiry-form-step__step font-weight-500">STEP</span>
      <span 
        v-for="step in max"
        :key="step"
        :class="step === currentSlideIndex + 1 ? 'inquiry-form-step__active' : 'inquiry-form-step__noactive'">
        {{ step }}
      </span>
    </div>
  </div>
</template>
